import { Stack, SubHeading, Body, Button, Row, Col } from '@workramp/ui';
import { useState } from 'react';
import { ContentContainer } from './DocumentLayout.styles';

export const DocumentLayout = ({
  title,
  description,
  children,
  ctaLabelShow,
  ctaLabelHide,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  ctaLabelShow: string;
  ctaLabelHide: string;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showContent, setShowContent] = useState(false);
  return (
    <Stack size={2}>
      <Row align="center">
        <Col xs="auto">
          <Body level="sm">
            <strong>{title}</strong> generated
          </Body>
        </Col>
        <Col xs="auto">
          <Button onPress={() => setShowContent(!showContent)} variant="text-inline" size="sm">
            <Body level="sm">{showContent ? 'Hide' : 'Show'}</Body>
          </Button>
        </Col>
      </Row>
      {showContent && (
        <ContentContainer>
          <Stack size={4}>
            <Stack size={2}>
              <SubHeading level="md">{title}</SubHeading>
              <Body level="sm">
                <em>{description}</em>
              </Body>
            </Stack>

            {!isExpanded ? (
              <Button onPress={() => setIsExpanded(true)} variant="outline" size="sm">
                {ctaLabelShow}
              </Button>
            ) : (
              <Stack size={4}>
                {children}
                <Button onPress={() => setIsExpanded(false)} variant="outline" size="sm">
                  {ctaLabelHide}
                </Button>
              </Stack>
            )}
          </Stack>
        </ContentContainer>
      )}
    </Stack>
  );
};
